export default __webpack_public_path__ + "static/media/video.3be5e647.svg";